// AsksList (Domain/Price book, DEC-019): what techs asked the office to add to the book, from a job,
// when it isn't there ("Ask the office to add it"): what they asked for and how often, who asked on
// which job, where it stands, and what the office does with it: add it to the book, price it for just
// that job, or turn it down. One waiting on an OK is drawn dashed (it waits on someone). Who can't
// change the book sees where each stands, without the actions. Reads only --asks-*; LineTable and Link
// read their own.
import { LineTable } from '../../components/LineTable/LineTable.tsx';
import { Link } from '../../components/Link/Link.tsx';
import './AsksList.css';

export interface AskRow {
  id: string;
  what: string;
  /** How many times it's been asked for. */
  times: number;
  who: string;
  job: string;
  when: string;
  state: 'Asked' | 'Being shaped' | 'Waiting for an OK';
}

export interface AsksListProps {
  asks: AskRow[];
  /** The office's: with these, each row has its actions. */
  onAdd?: (id: string) => void;
  onJustThisJob?: (id: string) => void;
  onTurnDown?: (id: string) => void;
}

export function AsksList({ asks, onAdd, onJustThisJob, onTurnDown }: AsksListProps) {
  const acts = !!(onAdd || onJustThisJob || onTurnDown);
  return (
    <LineTable
      label="Asked by techs"
      columns={[
        { id: 'what', label: 'What they asked for' },
        { id: 'who', label: 'Who, on which job' },
        { id: 'state', label: 'Where it stands' },
        ...(acts ? [{ id: 'act', label: 'What to do' }] : []),
      ]}
      rows={asks.map((a) => ({
        id: a.id,
        cells: {
          what: (
            <span className="fl-asks__what">
              <b className="fl-asks__strong">{a.what}</b>
              {a.times > 1 ? <span className="fl-asks__muted">asked {a.times} times</span> : null}
            </span>
          ),
          who: (
            <span className="fl-asks__what">
              <span>{a.who}</span>
              <span className="fl-asks__muted">
                {a.job} · {a.when}
              </span>
            </span>
          ),
          state: (
            <span className="fl-asks__state" data-waiting={a.state === 'Waiting for an OK' ? '' : undefined}>
              {a.state}
            </span>
          ),
          act: (
            <span className="fl-asks__acts">
              {onAdd ? <Link onPress={() => onAdd(a.id)}>Add to the book</Link> : null}
              {onJustThisJob ? <Link onPress={() => onJustThisJob(a.id)}>Just this job</Link> : null}
              {onTurnDown ? <Link onPress={() => onTurnDown(a.id)}>Turn down</Link> : null}
            </span>
          ),
        },
      }))}
    />
  );
}
